import { Component, Inject, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-read-report-modal',
  templateUrl: './read-report-modal.component.html',
  styleUrls: ['./read-report-modal.component.scss']
})
export class ReadReportModalComponent {

  public message: string = "";

  createReportQueueForm = new FormGroup({
    generation_date: new FormControl(null, [
      Validators.required,
    ]),
    generation_time: new FormControl(null, [
      Validators.required,
    ]),
  });

  constructor(
    public dialogRef: MatDialogRef<ReadReportModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.initialData();
  }

  initialData() {
    this.message = this.data.message;
  }

  closeModal() {
    this.dialogRef.close(false);
  }
}
